module.exports = __webpack_public_path__ + "img/time.d28346a0.svg";